import { ActionConfig, ActionType, ReviewResult, TooltipId } from "./types";
import { PreviewBorderColor } from "../DataList";
import XIcon from "assets/icons/FloatIcons/XIcon";
import CheckIcon from "assets/icons/FloatIcons/CheckIcon";
import IgnoreIcon from "assets/icons/FloatIcons/IgnoreIcon";
import AddTagIcon from "assets/icons/AddTagIcon";

export const getBorderColorByResult: Record<
  ReviewResult,
  PreviewBorderColor | undefined
> = {
  CORRECT: "green",
  INCORRECT: "red",
  IGNORE: undefined,
  REASSIGN: "red",
  INFERRED: "green",
  REVERT: undefined,
};

export const getOpacityByResult: Record<ReviewResult, number> = {
  CORRECT: 100,
  INCORRECT: 100,
  IGNORE: 50,
  REASSIGN: 100,
  INFERRED: 100,
  REVERT: 100,
};

export const TOOLTIP_TEXT: Record<ActionType, Record<TooltipId, string>> = {
  SINGLE: {
    INCORRECT:
      "Reject: This image does not belong to the current class. It will be reassigned to the next-best predicted class and marked for review.",
    CORRECT: "Approve: This image correctly belongs to the current class.",
    IGNORE:
      "Ignore: This image doesn't fit any class. It will be excluded from labeling and placed in an 'Unlabeled' group.",
    REASSIGN:
      "Assign to another class: Reassign this image to the correct class based on your knowledge.",
  },
  BULK: {
    INCORRECT:
      "Reject: These images do not belong to the current class. They will be reassigned to the next-best predicted class and marked for review.",
    CORRECT: "Approve: These images correctly belong to the current class.",
    IGNORE:
      "Ignore: These images don't fit any class. They will be excluded from labeling and placed in an 'Unlabeled' group.",
    REASSIGN:
      "Assign to another class: Reassign these images to the correct class based on your knowledge.",
  },
};

export const getTooltipText = (actionType: ActionType, id: TooltipId): string =>
  TOOLTIP_TEXT[actionType][id];

export const actionListConfigs: ActionConfig[] = [
  {
    text: "decline",
    icon: <XIcon />,
    color: "danger",
    result: "INCORRECT",
    needsConfirmation: true,
  },
  {
    text: "approve",
    icon: <CheckIcon />,
    color: "success",
    result: "CORRECT",
  },
  {
    text: "ignore",
    icon: <IgnoreIcon />,
    color: "warning",
    result: "IGNORE",
  },
  {
    text: "reassign",
    icon: <AddTagIcon />,
    color: "primary",
    result: "REASSIGN",
    hasSubAction: true,
  },
];
